module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('email'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrapper-left"
  }, [_c('news')], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-right"
  }, [_c('tel')], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("版权信息：© 2016 中南民族大学")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/dzlogo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "ch_title"
  }, [_vm._v("校长信箱")]), _vm._v(" "), _c('span', {
    staticClass: "en_title"
  }, [_vm._v("The principal mailbox")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73f7d6e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 569
// module chunks = 0